// extracted by mini-css-extract-plugin
export var category = "_l0-9";
export var categoryHeader = "_l0-e";
export var container = "_l0-0";
export var group = "_l0-a";
export var groupItems = "_l0-f";
export var groupSeparator = "_l0-j";
export var loading = "_l0-1";
export var noResults = "_l0-3";
export var placeholder = "_l0-2";
export var resultContent = "_l0-5";
export var resultIcon = "_l0-c";
export var resultItem = "_l0-g";
export var resultMeta = "_l0-8";
export var resultSubtitle = "_l0-7";
export var resultSuffix = "_l0-i";
export var resultTitle = "_l0-6";
export var resultsList = "_l0-4";
export var searchGroup = "_l0-d";
export var selected = "_l0-h";
export var subgroup = "_l0-b";